export const HELP_UPDATE_INFO = {
  formTitle: "Help Update",
  formTitleForNew: "New Help Update",
  path: "/helpupdates",
  listPage: "/help-updates",
}

const TAG_OPTIONS = [
  { value: "feature", label: "New" },
  { value: "fix", label: "Fix" },
  { value: "note", label: "Heads up" },
]

const STATUS_OPTIONS = [
  { value: "draft", label: "Draft" },
  { value: "published", label: "Published" },
]

export const HELP_UPDATE_FORM_TEMPLATE = {
  bodySections: {
    basic: {
      sectionType: "basic",
      sectionTypeId: "BASIC",
      expandable: false,
      breakPoint: 2,
      fieldName: "helpUpdate",
      fieldItems: [
        {
          label: "Title",
          type: "text",
          name: "title",
          initialFocus: true,
          validationProps: {
            required: "Title is required",
          }
        },
        {
          label: "Tag",
          type: "select-sync",
          name: "tag",
          required: false,
          initialFocus: false,
          options: TAG_OPTIONS,
          defaultValue: "feature",
        },
        {
          label: "Date",
          type: "date",
          name: "updateDate",
          initialFocus: false,
          validationProps: {
            required: "Date is required",
          }
        },
        {
          label: "Status",
          type: "select-sync",
          name: "status",
          required: false,
          initialFocus: false,
          options: STATUS_OPTIONS,
          defaultValue: "draft",
        },
        {
          label: "Short Description",
          type: "text",
          name: "shortDesc",
          initialFocus: false,
          validationProps: {
            required: "Short description is required",
          }
        },
        {
          label: "Detail Body (blank line = new paragraph; start a line with \"- \" for a bullet list, or \"1. \" for a numbered list) — optional",
          type: "textarea",
          name: "detailBody",
          initialFocus: false,
        },
        {
          label: "Related Article",
          type: "select",
          name: "relatedArticle",
          required: false,
          initialFocus: false,
          url: "/helparticleoptions",
        },
      ]
    },
  },
  watchFields: []
}
